import {Box, Text} from '@chakra-ui/react'
import {CommonColors} from '@utils/CommonStyles'

function FinishQuestion() {
  return (
    <Box
      width={'100%'}
      display={'flex'}
      justifyContent={'center'}
      flex={1}
      mt={'140px'}
      flexDirection={'column'}>
      <Box
        bg={CommonColors.white}
        alignSelf={'center'}
        maxW={600}
        borderRadius={24}
        padding={'20px'}>
        <Text fontSize={20} fontWeight={'400'} textAlign={'left'}>
          Bạn đã hoàn thành phần thi này
        </Text>
      </Box>
      <Box flex={1} />
    </Box>
  )
}

export default FinishQuestion
